import $ from 'jquery';

$(document).ready(function ($) {

    "use strict";

    let loader = function () {

        setTimeout(function () {
            if ($('#pb_loader').length > 0) {
                $('#pb_loader').removeClass('show');
            }
        }, 700);
    };
    loader();

    // scroll
    let scrollWindow = function () {
        $(window).scroll(function () {
            let $w = $(this),
                st = $w.scrollTop(),
                navbar = $('.pb_navbar'),
                sd = $('.js-scroll-wrap');

            if (st > 150) {
                if (!navbar.hasClass('scrolled')) {
                    navbar.addClass('scrolled');
                }
            }
            if (st < 150) {
                if (navbar.hasClass('scrolled')) {
                    navbar.removeClass('scrolled sleep');
                }
            }
            if (st > 350) {
                if (!navbar.hasClass('awake')) {
                    navbar.addClass('awake');
                }

                if (sd.length > 0) {
                    sd.addClass('sleep');
                }
            }
            if (st < 350) {
                if (navbar.hasClass('awake')) {
                    navbar.removeClass('awake');
                    navbar.addClass('sleep');
                }
                if (sd.length > 0) {
                    sd.removeClass('sleep');
                }
            }
        });
    };
    scrollWindow();

    // navigation
    let OnePageNav = function () {
        let navToggler = $('.navbar-toggler');
        $(".smoothscroll[href^='#'], #probootstrap-navbar ul li a[href^='#']").on('click', e => {
            e.preventDefault();
            let hash = this.hash;

            $('html, body').animate({

                scrollTop: $(hash).offset().top
            }, 700, 'easeInOutExpo', function () {
                window.location.hash = hash;
            });
        });
        $("#probootstrap-navbar ul li a[href^='#']").on('click', () => {
            if (navToggler.is(':visible')) {
                navToggler.click();
            }
        });

        $('body').on('activate.bs.scrollspy', function () {
            return true;
        })
    };
    OnePageNav();

    let offCanvasNav = function () {
        let toggleNav = $('.js-pb_nav-toggle'),
            offcanvasNav = $('.js-pb_offcanvas-nav_v1');
        if (toggleNav.length > 0) {
            toggleNav.click(function (e) {
                $(this).toggleClass('active');
                offcanvasNav.addClass('active');
                e.preventDefault();
            });
        }
        offcanvasNav.click(function (e) {
            if (offcanvasNav.hasClass('active')) {
                offcanvasNav.removeClass('active');
                toggleNav.removeClass('active');
            }
            e.preventDefault();
        })
    };
    offCanvasNav();

    let ytpPlayer = function () {
        if ($('.ytp_player').length > 0) {
            $('.ytp_player').mb_YTPlayer();
        }
    }
    ytpPlayer();


});

